import { Card } from "antd";
import Text from 'antd/es/typography/Text';

interface IProps {
    theme: 'light' | 'dark';
    label: string;
    value: string | number
}

export const CardItem = ({ theme, label, value }: IProps) => {

    return (
        <Card bodyStyle={{ padding: 12 }} className='info-item' style={{
            borderRadius: 8,
            padding: 0,
            background: theme === "light" ? "#f8f9fa" : "#222",
        }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <Text className='section-label' type='secondary' style={{ fontSize: 12, marginBottom: 4 }}>{label}:</Text>
                <Text className='section-text' style={{ fontWeight: 'bold' }}>{value}</Text>
            </div>
        </Card>
    );
};
